import { RouteProps } from "react-router-dom"
import Loadable from "../common/component/Loadable"

export interface AuthorityRouteProps extends RouteProps {
  requiredAuth?: boolean
}

export const routes: AuthorityRouteProps[] = [
  {
    path: "/",
    exact: true,
    component: Loadable(() => import("../routes/DashBoard")),
    requiredAuth: true,
  },
  {
    path: "/editchart/:id",
    exact: true,
    component: Loadable(() => import("../routes/EditChart")),
    requiredAuth: true,
  },
  {
    path: "/panel/create",
    exact: true,
    component: Loadable(() => import("../routes/CreatePanel")),
    requiredAuth: true,
  },
  {
    path: "/panel/:id",
    exact: true,
    component: Loadable(() => import("../routes/MyPanel")),
    requiredAuth: true,
  },
  {
    path: "/ncov",
    exact: true,
    component: Loadable(() => import("../routes/NCov")),
    requiredAuth: true,
  },
  {
    path: "/ncov/:id",
    exact: true,
    component: Loadable(() => import("../routes/NCovPanel")),
    requiredAuth: true,
  },
  {
    path: "/wayzchart/:type",
    exact: true,
    component: Loadable(() => import("../routes/WayzDataChart")),
    requiredAuth: true,
  },
  {
    path: "/datasource/file",
    component: Loadable(() => import("../routes/DatasourceFile")),
    exact: true,
    requiredAuth: true,
  },
  {
    path: "/industrydb",
    exact: true,
    component: Loadable(() => import("../routes/Industrydb")),
    requiredAuth: true,
  },
  {
    path: "/industrydb/:id",
    exact: true,
    component: Loadable(() => import("../routes/IndustrydbPanel")),
    requiredAuth: true,
  },
]
